import { CircleMarker, Popup, Tooltip } from "react-leaflet";

// Demo stations live on a 3000 x 2000 m schematic; place them at indicative spots around Tin Can (DEMO only).
const toLatLon = (s) => [6.4325 + (s.y - 740) / 111000, 3.333 + (s.x / 3000) * 0.025];

const latestText = (s) => {
  const l = s.latest || {};
  if (l.wind) return `wind ${l.wind.wind_speed_mps} m/s from ${Math.round(l.wind.wind_from_deg)}°`;
  const k = Object.keys(l)[0];
  return k ? `${k.toUpperCase()} ${l[k].value ?? "—"} ${l[k].unit || ""}` : "no data";
};

export function SensorLayer({ stations, zoom }) {
  if (zoom < 13) return null;
  return (stations || []).map((s) => (
    <CircleMarker key={s.station_id} center={toLatLon(s)} radius={7} pathOptions={{ color: "#FDE047", weight: 2, fillColor: s.role === "MET" ? "#38BDF8" : "#A3E635", fillOpacity: 0.9 }}>
      <Tooltip permanent direction="right" offset={[8, 0]} className="ship-label" opacity={1}>{s.name}</Tooltip>
      <Popup><strong>{s.name}</strong> · DEMO sensor<br />{s.role} · {latestText(s)}<br />indicative position, synthetic data</Popup>
    </CircleMarker>
  ));
}
